import SchoolsAdd from "./SchoolsAdd";

export default SchoolsAdd;
